import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modalRef!: NgbModalRef;

  constructor(private readonly modalService: NgbModal) {}

  openModal(template: any): void {
    this.modalRef = this.modalService.open(template, {
      centered: true,
      windowClass: 'custom-modal-window'
    });

    this.modalRef.result.catch(() => {});
  }

  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

}